import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import scrollToComponent from 'react-scroll-to-component';

import {diamondImgUrl, diamondTitle, diamondPrice, settingCartDesc} from '../../../../../utils/formatting';
import {getMetalTypeChildDropdownData, calcChildMetalMarkup, getMinPrice} from '../../../../../utils/product';

import {ringSizes} from '../../../../../constants/ringsizes';

import * as cartActionCreators from '../../../../../actions/cart';
import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, cartActionCreators, productActionCreators);

import {ResultsControlsContainer} from './ResultsControls';
import RhinoLoading from '../../../common/RhinoLoading';
import RhinoSelect from '../../../../common/inputs/RhinoSelect';
import {FloatingHeaderContainer} from '../blocks/FloatingHeader';

import {SettingGridContainer} from './grids/SettingGrid';
import {CompareProductsContainer} from '../blocks/CompareProducts';

class SettingResults extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    let ringLabel = [
      {
        display: 'Size',
        value: '',
      }
    ];

    this.state = {
      upperTabSelected: 'best',
      nextStepsOpen: false,

      ringSizeData: ringLabel.concat(ringSizes),

      ringSize: this.props.product && this.props.product.attrSize ? this.props.product.attrSize : '',
      metalType: this.props.product && this.props.product.attrMetal ? this.props.product.attrMetal : '',
      validationMessage: '',
      addingToCart: false,

      assembledOpen: true,

      openedClass: ' opened',
    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  getMetals() {
    if(!this.props.product.selectedSetting || !this.props.product.selectedSetting.price) {
      return [];
    }
    return getMetalTypeChildDropdownData(this.props.product.selectedSetting);
  }

  changeMetalType(evt) {
    this.setState({
      metalType: evt.target.value,
      validationMessage: '',
    }, () => {
      this.props.productSelectSetting(this.props.product.selectedSetting, this.state.metalType, this.props.product.attrSize);
    });
  }

  changeRingSize(evt) {
    this.setState({
      ringSize: evt.target.value,
      validationMessage: '',
    }, () => {
      this.props.productSelectSetting(this.props.product.selectedSetting, this.props.product.attrMetal, this.state.ringSize);
    });
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getProductMainImage(product) {
    if(product.image_count > 0) {
      return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
    }
  }

  setResultsDisplayType(displayValue) {
    this.setState({ resultsDisplayType: displayValue });
  }

  scrollTop() {
    scrollToComponent(this.topSection, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
    this.setState({ upperTabSelected: 'best' });
  }

  scrollCompare() {
    scrollToComponent(this.topSection, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
    this.setState({ upperTabSelected: 'picks' });
  }

  getFavesLength() {
    return this.props.product.compareSettings.length.toString();
  }

  isSettingSelected() {
    return this.props.product.selectedSetting !== null;
  }

  selectSetting(product) {
    this.props.productSelectSetting(product);
  }

  selectUpperTab(tabVal) {
    this.setState({ upperTabSelected: tabVal });
  }

  toggleNextSteps() {
    this.setState({ nextStepsOpen: !this.state.nextStepsOpen });
  }

  getMetalKarat(setting) {
    if(!setting) {
      return 14;
    }
    let setVal = setting.karat;
    if(setting.attributes) {
      setVal = setting.attributes.karat;
    }
    if(!setVal) {
      setVal = 14;
    }
    return setVal;
  }

  addToCart() {

    if(!this.state.metalType) {
      this.setState({validationMessage: 'Please select a metal type'});
      return;
    }

    if(!this.state.ringSize) {
      this.setState({validationMessage: 'Please select a ring size'});
      return;
    }

    let markup = parseInt(calcChildMetalMarkup(this.props.product.selectedSetting, this.state.metalType));
    let basePrice = getMinPrice(this.props.product.selectedSetting);

    this.setState({ addingToCart: true });

    this.props.productFetchBySku(this.props.product.selectedSetting.sku)
    .then((respData) => {

      this.props.cartAddMetalSize(this.props.product.selectedSetting.sku, this.state.metalType, this.state.ringSize, this.getMetalKarat(this.props.product.selectedSetting), markup, basePrice, settingCartDesc(respData.success, this.state.metalType, this.state.ringSize))
      .then((resp) => {
        console.log(resp);
        this.externalNav('checkout/cart');
      })
      .catch((errResp) => {
        this.setState({ addingToCart: false });
      });
    })
    .catch((errResp) => {
      this.setState({ addingToCart: false });
    });
  }

  addDiamond() {
    this.props.setParentMode('mixed');
    // this.internalNav('gallery/engagement-rings');
  }

  scrollToResults() {
    if(!this.resultsSection) { return; }
    scrollToComponent(this.resultsSection, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  getProductPrice() {
    if(!this.props.product.selectedSetting) {
      return '';
    }
    console.log(this.props.product.selectedSetting);
    console.log(this.props.product.selectedSetting.price);
    return parseInt(getMinPrice(this.props.product.selectedSetting)) + parseInt(calcChildMetalMarkup(this.props.product.selectedSetting, this.state.metalType));
    // return parseInt(this.props.product.selectedSetting.price);
  }

  toggleAssembled() {
    this.setState({
      assembledOpen: !this.state.assembledOpen,
      openedClass: '',
    }, () => {
      if(this.state.assembledOpen) {
        setTimeout(() => {
          this.setState({ openedClass: ' opened' });
        }, 500);
      }
    });
  }

  render() {

    const RESULT_LIMIT = 24;

    let pCount = 0;
    let dCount = 0;

    return <div className='SettingResults' ref={(div) => { this.topSection = div; }}>

      <FloatingHeaderContainer 
        scrollTop={::this.scrollTop}
        scrollCompare={::this.scrollCompare}
        getFavesLength={::this.getFavesLength} />

      <div className={this.state.assembledOpen ? `assembledWrapper open ${this.state.openedClass}` : 'assembledWrapper'}>
        <div className='assembledToggle' onClick={::this.toggleAssembled}>
          {this.state.assembledOpen ?
            <div className='assembledToggleIcon'>&mdash;</div> :
            <div className='assembledToggleIcon'>+</div>
          }
        </div>
        <div className={'assembledTabsWrapper desktopOnly'}>
          <div className={this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('best')}>Your Setting</div>
          <div className={this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('picks')}>Compare Settings ({this.getFavesLength()} of 4)</div>
        </div>
        <div className={'assembledTabsWrapper mobileOnly'}>
          <div className={this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('best')}>Your Setting</div>
          <div className={this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('picks')}>Compare</div>
        </div>
        {this.state.upperTabSelected == 'best' ?
          <div className='assembledPreview'>
            <div className='assembledVBR'></div>
            <div className={'assembledComponentWrapper fullWidth'}>
              {this.isSettingSelected() ?
                <div className='settingComponentWrapper' style={{borderBottom: 'none'}}>
                  <div className='settingComponentImageWrapper'>
                    <img src={this.getProductMainImage(this.props.product.selectedSetting)} />
                  </div>
                  <div className='settingComponentInfoWrapper'>
                    <div className='settingInfoTitleRow'>
                      <span className='settingInfoTitle'>{this.props.product.selectedSetting.name}</span>
                      <span className='removeLink' onClick={() => this.props.productSelectSetting(null)}>remove</span>
                    </div>
                    <div className='settingInfoCustomRow'>
                      <div className='settingInfoPrice'>${this.getProductPrice()}</div>
                      <div className='priceNotice'>(setting&nbsp;&nbsp;only)</div>
                    </div>
                    <div className='settingInfoCustomWrapper'>
                      {this.state.validationMessage ? 
                        <div className='configError'>{this.state.validationMessage}</div> :
                        null
                      }
                      <div className='metalTypeOptions'>
                        <RhinoSelect
                          options={this.getMetals()}
                          value={this.state.metalType}
                          changeMethod={::this.changeMetalType}
                          rootClass='productSelect' />
                      </div>
                      <div className='ringSizeSelect'>
                        <RhinoSelect
                          options={this.state.ringSizeData}
                          value={this.state.ringSize}
                          changeMethod={::this.changeRingSize}
                          rootClass='productSelect' />
                      </div>
                    </div>
                    <div className='settingInfoButtonRow'>
                      {this.state.addingToCart ?
                        <div className='nextStepsInCart'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
                        <div className='nextStepsWrapper'>
                          <div className='nextStepsElement' onClick={::this.toggleNextSteps}>
                            <div className='nextStepsHead'>
                              <div className='nextStepsLabel'>Next Steps</div>
                              <div className='nextStepsIcon'>
                                <img src='https://ddw2.diamondsdirect.com/img/productpage/down.svg' />
                              </div>
                            </div>
                            <div className={this.state.nextStepsOpen ? 'nextStepsBody open' : 'nextStepsBody'}>
                              <div className='nextStepsBodyWrapper'>
                                <div className='nextStepsItem' onClick={() => this.addToCart()}>Add to Cart</div>
                                <div className='nextStepsItem' onClick={() => this.internalNav('setting/' + this.props.product.selectedSetting.sku)}>View Setting</div>
                                <div className='nextStepsItem' onClick={() => this.addDiamond()}>Add to Ring</div>
                                <div className='nextStepsItem' onClick={() => this.internalNav('contact-us')}>Request an Appointment</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div> :
                <div className='settingMessageWrapper'>
                  <div className='settingNullMessage'>Choose a setting below to get started!</div>
                </div>
              }
            </div>
          </div> :
          <CompareProductsContainer productType={'setting'} />
        }
      </div>
      
      <div className='resultsWrapper' ref={(div) => { this.resultsSection = div; }}>
        <div className='resultsTabWrapper'>
          <div className={'resultTab selectedTab'}>Setting Results</div>
        </div>
        <div className='resultsBody' ref={(div) => { this.resultsBody = div; }}>
          <SettingGridContainer 
            updateMethod={::this.props.updateMethod} 
            scrollUp={::this.scrollToResults} 
            showSplashPage={::this.props.showSplashPage}
            openFilters={this.props.openFilters} />
        </div>
      </div>


    </div>;
  }
}
export default SettingResults;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const SettingResultsContainer = connect(
  mapStateToProps,
  allActionCreators
)(SettingResults);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/results/SettingResults.jsx